import { ExternalUrlValue } from "app/area/external-url-groups/form/types-store";

export const createExternalUrls = (
  values: ExternalUrlValue[]
) => values.map((value, index) => ({
  code: { value: value.value, description: value.description, longDescription: value.longDescription },
  sequence: index + 1,
  urlTemplate: value.urlTemplate,
  disabled: value.disabled
}));
